import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

// styles
import { WrapBusinessWaitingUpdate } from './index.styles'
import { TableContentBusiness, TableHeaderBusiness, TableWaitingListBusiness, WrapWaitingListBusiness } from '../BusinessWaiting/index.styles';

// component
import FilterBusinessManage from '../FilterBusiness'
import BussinessManagerDetails from '../BusinessManagerDetails'
import BusinessItem from '../BusinessWaiting/BusinessItem';
import EmptyDataControl from '../../../../../Control/EmptyDataControl';

// data
import { headerWaitingBusiness, listNoteBusiness } from '../../../../../../data/dataWaitingCensorship';

// images
import IcDefaultBusiness from '../../../../../../assets/images/IcDefaultBusiness';

// hook
import useScrollEnd from '../../../../../../hook/useScrollEnd';

// redux
import { getListBusiness, resetBusinessDetail } from '../../../../../../redux/business/listBusinessManage/action';

// constant
import { BUSINESS_WAITING_UPDATE } from '../../../../../../constant/keys';

const BusinessWaitingUpdate = () => {

  const listRef = useRef(null)
  const dispatch = useDispatch()

  const [isShowPopup, setIsShowPopup] = useState(false)

  const { condFiltersBusiness, total, listBussinessWaitingUpdate } = useSelector((state) => ({
    condFiltersBusiness: state.businessReducer.listBusinessManage.condFiltersBusiness,
    listBussinessWaitingUpdate: state.businessReducer.listBusinessManage.listBussiness,
    total: state.businessReducer.listBusinessManage.total,
  }))

  const dataRequest = (condFiltersBusiness, isScroll, listBussiness) => {
    return {
      isDenied: false,
      isNew: false,
      isRequireLicenseUpdate: true,
      isLicenseUpdated: false,
      businessCode: condFiltersBusiness.businessCode,
      phoneNumber: condFiltersBusiness.phoneNumber,
      ownerName: condFiltersBusiness.ownerName,
      businessName: condFiltersBusiness.businessName,
      begin: condFiltersBusiness.begin,
      end: condFiltersBusiness.end,
      limit: condFiltersBusiness.limit,
      lastItem: isScroll ? listBussiness.at(-1).id : condFiltersBusiness.lastItem,
    }
  }

  useEffect(() => {
    dispatch(getListBusiness(dataRequest(condFiltersBusiness, false), false))
  }, [condFiltersBusiness])

  useScrollEnd(listRef, (callback) => {
    dispatch(getListBusiness(dataRequest(condFiltersBusiness, true, listBussinessWaitingUpdate), true, callback))
  }, [listBussinessWaitingUpdate], [listBussinessWaitingUpdate.length])

  const _handleClosePopup = () => {
    setIsShowPopup(false)
    dispatch(resetBusinessDetail())
  }

  return (
    <WrapBusinessWaitingUpdate>
      <FilterBusinessManage isShowSelectCheckbox={false} />
      <WrapWaitingListBusiness>
        <TableWaitingListBusiness>
          {listBussinessWaitingUpdate?.length === 0 ? (
            <div className="wrap-empty">
              <EmptyDataControl
                icon={<IcDefaultBusiness />}
                text={"Hiện tại chưa có doanh nghiệp mới"}
              />
            </div>
          ) : (
            <>
              <div className="wrap-page-header">
                <p className="title-header">Danh sách hồ sơ ({total ? total : 0})</p>
                <div className="list-note">
                  {listNoteBusiness.map((item, index) => (
                    <div className="note" key={index}>
                      {item.key === BUSINESS_WAITING_UPDATE ? item.icon : ""}
                      <p>{item.key === BUSINESS_WAITING_UPDATE ? item.text : ""}</p>
                    </div>
                  ))}
                </div>
              </div>
              <TableHeaderBusiness>
                {headerWaitingBusiness.map((item, index) => (
                  <div className="table-header" key={index}>
                    {item}
                  </div>
                ))}
              </TableHeaderBusiness>
              <TableContentBusiness>
                <div className="wrap-list-waiting" ref={listRef}>
                  <div className="list-waiting">
                    {listBussinessWaitingUpdate?.map((item, index) => (
                      <BusinessItem key={index} data={item} setIsShowPopup={setIsShowPopup} />
                    ))}
                  </div>
                </div>
              </TableContentBusiness>
            </>
          )}
        </TableWaitingListBusiness>
      </WrapWaitingListBusiness>
      {
        isShowPopup &&
        <BussinessManagerDetails
          onClickClosePopup={_handleClosePopup} />
      }
    </WrapBusinessWaitingUpdate>
  )
}

export default BusinessWaitingUpdate